/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { Prisma, ResendEmailLog } from ".zenstack/models";
import type { UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { getHooksContext } from '@zenstackhq/tanstack-query/runtime-v5/react';
import { useModelQuery, useInfiniteModelQuery, useModelMutation } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { PickEnumerable, CheckSelect, QueryError, ExtraQueryOptions, ExtraMutationOptions } from '@zenstackhq/tanstack-query/runtime-v5';
import type { PolicyCrudKind } from '@zenstackhq/runtime'
import metadata from './__model_meta';
type DefaultError = QueryError;
import { useSuspenseModelQuery, useSuspenseInfiniteModelQuery } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { UseSuspenseQueryOptions, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';

export function useCreateResendEmailLog(options?: Omit<(UseMutationOptions<(ResendEmailLog | undefined), DefaultError, Prisma.ResendEmailLogCreateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendEmailLogCreateArgs, DefaultError, ResendEmailLog, true>('ResendEmailLog', 'POST', `${endpoint}/resendEmailLog/create`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendEmailLogCreateArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendEmailLogCreateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ResendEmailLog, Prisma.ResendEmailLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ResendEmailLogCreateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ResendEmailLog, Prisma.ResendEmailLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useCreateManyResendEmailLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ResendEmailLogCreateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendEmailLogCreateManyArgs, DefaultError, Prisma.BatchPayload, false>('ResendEmailLog', 'POST', `${endpoint}/resendEmailLog/createMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendEmailLogCreateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendEmailLogCreateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ResendEmailLogCreateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useFindManyResendEmailLog<TArgs extends Prisma.ResendEmailLogFindManyArgs, TQueryFnData = Array<Prisma.ResendEmailLogGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogFindManyArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/findMany`, args, options, fetch);
}

export function useInfiniteFindManyResendEmailLog<TArgs extends Prisma.ResendEmailLogFindManyArgs, TQueryFnData = Array<Prisma.ResendEmailLogGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogFindManyArgs>, options?: Omit<UseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useInfiniteModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/findMany`, args, options, fetch);
}

export function useSuspenseFindManyResendEmailLog<TArgs extends Prisma.ResendEmailLogFindManyArgs, TQueryFnData = Array<Prisma.ResendEmailLogGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogFindManyArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/findMany`, args, options, fetch);
}

export function useSuspenseInfiniteFindManyResendEmailLog<TArgs extends Prisma.ResendEmailLogFindManyArgs, TQueryFnData = Array<Prisma.ResendEmailLogGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogFindManyArgs>, options?: Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseInfiniteModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/findMany`, args, options, fetch);
}

export function useFindUniqueResendEmailLog<TArgs extends Prisma.ResendEmailLogFindUniqueArgs, TQueryFnData = Prisma.ResendEmailLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogFindUniqueArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/findUnique`, args, options, fetch);
}

export function useSuspenseFindUniqueResendEmailLog<TArgs extends Prisma.ResendEmailLogFindUniqueArgs, TQueryFnData = Prisma.ResendEmailLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogFindUniqueArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/findUnique`, args, options, fetch);
}

export function useFindFirstResendEmailLog<TArgs extends Prisma.ResendEmailLogFindFirstArgs, TQueryFnData = Prisma.ResendEmailLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogFindFirstArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/findFirst`, args, options, fetch);
}

export function useSuspenseFindFirstResendEmailLog<TArgs extends Prisma.ResendEmailLogFindFirstArgs, TQueryFnData = Prisma.ResendEmailLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogFindFirstArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/findFirst`, args, options, fetch);
}

export function useUpdateResendEmailLog(options?: Omit<(UseMutationOptions<(ResendEmailLog | undefined), DefaultError, Prisma.ResendEmailLogUpdateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendEmailLogUpdateArgs, DefaultError, ResendEmailLog, true>('ResendEmailLog', 'PUT', `${endpoint}/resendEmailLog/update`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendEmailLogUpdateArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendEmailLogUpdateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ResendEmailLog, Prisma.ResendEmailLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ResendEmailLogUpdateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ResendEmailLog, Prisma.ResendEmailLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useUpdateManyResendEmailLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ResendEmailLogUpdateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendEmailLogUpdateManyArgs, DefaultError, Prisma.BatchPayload, false>('ResendEmailLog', 'PUT', `${endpoint}/resendEmailLog/updateMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendEmailLogUpdateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendEmailLogUpdateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ResendEmailLogUpdateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useUpsertResendEmailLog(options?: Omit<(UseMutationOptions<(ResendEmailLog | undefined), DefaultError, Prisma.ResendEmailLogUpsertArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendEmailLogUpsertArgs, DefaultError, ResendEmailLog, true>('ResendEmailLog', 'POST', `${endpoint}/resendEmailLog/upsert`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendEmailLogUpsertArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendEmailLogUpsertArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ResendEmailLog, Prisma.ResendEmailLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ResendEmailLogUpsertArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ResendEmailLog, Prisma.ResendEmailLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteResendEmailLog(options?: Omit<(UseMutationOptions<(ResendEmailLog | undefined), DefaultError, Prisma.ResendEmailLogDeleteArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendEmailLogDeleteArgs, DefaultError, ResendEmailLog, true>('ResendEmailLog', 'DELETE', `${endpoint}/resendEmailLog/delete`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendEmailLogDeleteArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendEmailLogDeleteArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ResendEmailLog, Prisma.ResendEmailLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ResendEmailLogDeleteArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ResendEmailLog, Prisma.ResendEmailLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteManyResendEmailLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ResendEmailLogDeleteManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendEmailLogDeleteManyArgs, DefaultError, Prisma.BatchPayload, false>('ResendEmailLog', 'DELETE', `${endpoint}/resendEmailLog/deleteMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendEmailLogDeleteManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendEmailLogDeleteManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ResendEmailLogDeleteManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useAggregateResendEmailLog<TArgs extends Prisma.ResendEmailLogAggregateArgs, TQueryFnData = Prisma.GetResendEmailLogAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogAggregateArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/aggregate`, args, options, fetch);
}

export function useSuspenseAggregateResendEmailLog<TArgs extends Prisma.ResendEmailLogAggregateArgs, TQueryFnData = Prisma.GetResendEmailLogAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogAggregateArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/aggregate`, args, options, fetch);
}

export function useGroupByResendEmailLog<TArgs extends Prisma.ResendEmailLogGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.ResendEmailLogGroupByArgs['orderBy'] } : { orderBy?: Prisma.ResendEmailLogGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.ResendEmailLogGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.ResendEmailLogGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.ResendEmailLogGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.ResendEmailLogGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.ResendEmailLogGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/groupBy`, args, options, fetch);
}

export function useSuspenseGroupByResendEmailLog<TArgs extends Prisma.ResendEmailLogGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.ResendEmailLogGroupByArgs['orderBy'] } : { orderBy?: Prisma.ResendEmailLogGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.ResendEmailLogGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.ResendEmailLogGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.ResendEmailLogGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.ResendEmailLogGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.ResendEmailLogGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/groupBy`, args, options, fetch);
}

export function useCountResendEmailLog<TArgs extends Prisma.ResendEmailLogCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.ResendEmailLogCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogCountArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/count`, args, options, fetch);
}

export function useSuspenseCountResendEmailLog<TArgs extends Prisma.ResendEmailLogCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.ResendEmailLogCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendEmailLogCountArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/count`, args, options, fetch);
}

export function useCheckResendEmailLog<TError = DefaultError>(args: { operation: PolicyCrudKind; where?: { createdById?: string; updatedById?: string; deletedById?: string; id?: string; fromEmail?: string; toEmail?: string; subject?: string; replyTo?: string; resendMessageId?: string; resendError?: string; resendStatusCode?: number; resendErrorName?: string; userEmail?: string; userName?: string; category?: string; message?: string; success?: boolean }; }, options?: (Omit<UseQueryOptions<boolean, TError, boolean>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<boolean, boolean, TError>('ResendEmailLog', `${endpoint}/resendEmailLog/check`, args, options, fetch);
}
